import React from 'react'
import camera from '../../assets/images/focus 1.png'
import { Add, ChevronRight, KeyboardArrowDown } from '@mui/icons-material';
import oil from '../../assets/images/icon1.png'
import tire from '../../assets/images/icon2.png'
import battery from '../../assets/images/icon3.png'
import note from "../../assets/images/note-1-svgrepo-com 1.png";
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

export default function OrderServices() {

  return (
    <div className=" m-4">
      <div className="row">
        {/* head  */}
        <div className="col-12 mb-2 d-flex justify-content-between align-items-center">
          <div className="cursor">
            <img src={camera} alt="" />
          </div>
          <p className="fs-5 my-0">
            <span className=" fw-bold">ORD-3247# </span>
            خدمات الطلب
          </p>
          <div className="cursor">
            <ChevronRight />
          </div>
        </div>
        {/* text  */}
        <div className="col-12 my-2 text-end text-lg-center">
          <p className="small mx-2 fw-semibold">
            راجع الخدمات المنفذة من قِبل الفني قبل تأكيد الطلب
          </p>
        </div>
        {/* services */}
        {/* oils & filters */}
        <div className="col-sm-12 my-2 col-lg-6">
          <div className="border border-1 border-light rounded-2 p-2">
            {/* name & image  */}
            <div className=" d-flex justify-content-end align-items-center">
              <p className=" my-0 text-muted">خدمه فحص الزيوت والفلاتر</p>
              <div className=" mx-2">
                <img src={oil} alt="" />
              </div>
            </div>
            {/* service checkboxes */}
            <div className="d-flex justify-content-evenly align-items-center my-2">
              <div>
                <img src={note} alt="" />
              </div>
              <div className=" d-flex">
                <p className=" fw-bold my-0 mx-3">ج.م</p>
                <p className=" fw-bold my-0">100.0</p>
              </div>
              <div className="w-50 text-center">
                <p className=" my-0 w-100">كشف علي زيت الماتور</p>
              </div>
              <div className=" d-flex justify-content-center align-items-center mt-1">
                <input
                  className=" form-control-lg "
                  type="checkbox"
                  name=""
                  id=""
                />
                <input
                  className="mx-3 form-control-lg"
                  type="checkbox"
                  name=""
                  id=""
                />
              </div>
            </div>
            {/* service checkboxes */}
            <div className=" d-flex justify-content-evenly align-items-center my-2">
              <div>
                <img src={note} alt="" />
              </div>
              <div className=" d-flex">
                <p className=" fw-bold my-0 mx-3">ج.م</p>
                <p className=" fw-bold my-0">100.0</p>
              </div>
              <div className=" w-50 text-center">
                <p className=" my-0 w-100">فحص تسريب زيت </p>
              </div>
              <div className=" d-flex justify-content-center align-items-center mt-1">
                <input
                  className="form-control-lg "
                  type="checkbox"
                  name=""
                  id=""
                />
                <input
                  className="mx-3 form-control-lg"
                  type="checkbox"
                  name=""
                  id=""
                />
              </div>
            </div>
            {/* service checkboxes */}
            <div className=" d-flex justify-content-evenly align-items-center my-2">
              <div>
                <img src={note} alt="" />
              </div>
              <div className=" d-flex">
                <p className=" fw-bold my-0 mx-3">ج.م</p>
                <p className=" fw-bold my-0">100.0</p>
              </div>
              <div className=" w-50 text-center">
                <p className="w-100 my-0"> فحص فلتر الزيت و تنضيفه</p>
              </div>
              <div className=" d-flex justify-content-center align-items-center mt-1">
                <input
                  className="form-control-lg "
                  type="checkbox"
                  name=""
                  id=""
                />
                <input
                  className="mx-3 form-control-lg"
                  type="checkbox"
                  name=""
                  id=""
                />
              </div>
            </div>
          </div>
        </div>
        {/* Tires */}
        <div className="col-sm-12 my-2 col-lg-6">
          <div className="border border-1 border-light rounded-2 p-2">
            {/* tire check service  */}
            {/* name & image  */}
            <div className=" d-flex justify-content-end align-items-center">
              <p className=" my-0 text-muted">خدمه فحص و كشف الكاوتش </p>
              <div className=" mx-2">
                <img src={tire} alt="" />
              </div>
            </div>
            {/*check service checkboxes */}
            <div className="d-flex justify-content-evenly align-items-center my-2">
              <div>
                <img src={note} alt="" />
              </div>
              <div className=" d-flex">
                <p className=" fw-bold my-0 mx-3">ج.م</p>
                <p className=" fw-bold my-0">100.0</p>
              </div>
              <div className="w-50 text-center">
                <p className=" my-0 w-100"> كشف ثقوب </p>
              </div>
              <div className=" d-flex justify-content-center align-items-center mt-1">
                <input
                  className=" form-control-lg "
                  type="checkbox"
                  name=""
                  id=""
                />
                <input
                  className="mx-3 form-control-lg"
                  type="checkbox"
                  name=""
                  id=""
                />
              </div>
            </div>
            {/* check service inputs */}
            <div className="row me-1">
              <div className="col-6">
                <FormControl className="mx-2 w-100" variant="outlined">
                  <InputLabel id="لحام حقن مطاط">لحام حقن مطاط</InputLabel>
                  <Select
                    labelId="لحام حقن مطاط"
                    label="لحام حقن مطاط"
                    // {...register("status")}
                    defaultValue="لحام حقن مطاط"
                    // onChange={(e) => {
                    //   setAddMainCatigory({
                    //     ...addMainCatigory,
                    //     status: e.target.value,
                    //   });
                    // }}
                  >
                    <MenuItem className="custom-menu-item" value="1">
                      لحام حقن مطاط
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="col-6">
                <TextField
                  type="number"
                  placeholder="عدد الثقوب"
                  className="form-control"
                />
              </div>
            </div>
            {/* tire change service  */}
            {/* name & image  */}
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <img src={note} className=" px-1" alt="" />
              </div>
              <div className=" d-flex justify-content-start  align-items-center">
                <p className=" my-0 text-muted">خدمه تغيير كاوتش </p>
                <div className=" mx-2">
                  <img src={tire} alt="" />
                </div>
              </div>
            </div>
            {/*change service checkboxes */}
            <div className="d-flex justify-content-evenly align-items-center mt-2">
              <div>
                <KeyboardArrowDown />
              </div>
              <div className=" d-flex">
                <p className=" fw-bold my-0 mx-3">ج.م</p>
                <p className=" fw-bold my-0">100.0</p>
              </div>
              <div className="w-50 text-center">
                <p className=" my-0 w-100"> تغيير كاوتش </p>
              </div>
              <div className=" d-flex justify-content-center align-items-center mt-1">
                <input
                  className=" form-control-lg "
                  type="checkbox"
                  name=""
                  id=""
                />
                <input
                  className="mx-3 form-control-lg"
                  type="checkbox"
                  name=""
                  id=""
                />
              </div>
            </div>
            {/* nested change service details */}
            <div className="row bg-light p-2 rounded-3 mx-2 mb-2">
              <div className="col-5 d-flex flex-column text-end">
                <p className="my-2">
                  <span className=" text-muted"> الماركه : </span>
                  <span className=" fw-semibold"> بيريللي </span>
                  <span className="fw-bold mx-2">.</span>
                </p>
                <p className="my-2">
                  <span className=" text-muted"> العدد : </span>
                  <span className=" fw-semibold"> 1 </span>
                  <span className="fw-bold mx-2">.</span>
                </p>
              </div>
              <div className="col-7 d-flex flex-column text-end">
                <p className="my-2">
                  <span className=" fw-semibold"> Tubeless</span>
                  <span className=" text-muted"> : النوع </span>
                  <span className="fw-bold mx-2">.</span>
                </p>
                <p className="my-2">
                  <span className=" text-muted"> بلد المنشأ : </span>
                  <span className=" fw-semibold"> الماني </span>
                  <span className="fw-bold mx-2">.</span>
                </p>
                <p className="my-2">
                  <span className=" fw-semibold"> 15D / 12H / 16W</span>
                  <span className=" text-muted"> : الحجم </span>
                  <span className="fw-bold mx-2">.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* battery */}
        <div className="col-sm-12 my-2 col-lg-6">
          <div className="border border-1 border-light rounded-2 p-2">
            {/* name & image  */}
            <div className=" d-flex justify-content-end align-items-center">
              <p className=" my-0 text-muted"> خدمه فحص البطاريه </p>
              <div className=" mx-2">
                <img src={battery} alt="" />
              </div>
            </div>
            {/* service checkboxes */}
            <div className="d-flex justify-content-evenly align-items-center my-2">
              <div>
                <img src={note} alt="" />
              </div>
              <div className=" d-flex">
                <p className=" fw-bold my-0 mx-3">ج.م</p>
                <p className=" fw-bold my-0">100.0</p>
              </div>
              <div className="w-50 text-center">
                <p className=" my-0 w-100"> كشف علي البطارية</p>
              </div>
              <div className=" d-flex justify-content-center align-items-center mt-1">
                <input
                  className=" form-control-lg "
                  type="checkbox"
                  name=""
                  id=""
                />
                <input
                  className="mx-3 form-control-lg"
                  type="checkbox"
                  name=""
                  id=""
                />
              </div>
            </div>
            {/* service checkboxes */}
            <div className=" d-flex justify-content-evenly align-items-center my-2">
              <div>
                <img src={note} alt="" />
              </div>
              <div className=" d-flex">
                <p className=" fw-bold my-0 mx-3">ج.م</p>
                <p className=" fw-bold my-0">100.0</p>
              </div>
              <div className=" w-50 text-center">
                <p className=" my-0 w-100"> كشف دورة الكهرباء </p>
              </div>
              <div className=" d-flex justify-content-center align-items-center mt-1">
                <input
                  className="form-control-lg "
                  type="checkbox"
                  name=""
                  id=""
                />
                <input
                  className="mx-3 form-control-lg"
                  type="checkbox"
                  name=""
                  id=""
                />
              </div>
            </div>
          </div>
        </div>
        {/* more services */}
        <div className=" d-flex flex-column">
          <div className="my-2 text-end">
            <p className=" fw-semibold my-0 cursor">
              اضافة خدمه جديده
              <Add />
            </p>
          </div>
          <div className=" bg-light d-flex justify-content-between align-items-center p-3 rounded-3 my-2">
            <div className=" d-flex justify-content-end align-items-center">
              <p className=" fw-bold my-0">ج.م</p>
              <p className=" mx-2 my-0 fw-bold">100</p>
            </div>
            <p className=" my-0"> : اجمالي المبلغ</p>
          </div>
        </div>
        {/* service end */}
        <button className=" form-control bg-black text-white w-50 mx-auto my-2">
          تأكيد انهاء الطلب
        </button>
      </div>
    </div>
  );
}
